import { $_app_server } from '@/_helpers'

export const specialistService = {
  advocatApps,
  appStatuses,
  advocatApp, 
  advocatAppCreate,
  advocatAppItemCreate,
  advocatAppItemUpdate,
  advocatEventTypes,
  boostingKfs,
  getCase,
  findCase,
  findCases,
  advocatAppSend,
  advocatAppDelete,
  advocatAppItemDelete,
  staffApps, 
  staffApp,
  saveAppItem,
  confirmApp,
  reestr,
  groups,
  groupCreate,
  groupUpdate,
  specs,
  specCreate,
  specApprove,
  getProfileById,
  editProfile,
  editSpecialist,
  editBankAccount,
  getAuthSpecialist,
  makeReestr,
  signReestr,
  getAdvocatAppData, 
  postAdvocatAppData, 
}



function staffApps () {
  return $_app_server.get("specialist/apps")
  .then(response => response.data)
}

function staffApp (id) {
  return $_app_server.get("specialist/apps/"+id)
  .then(response => response.data)
}



function appStatuses () {
  return $_app_server.get("specialistappstatuses").then(response => response.data)
}

function boostingKfs () {
  return $_app_server.get("boostingkfs").then(response => response.data)
}

function advocatEventTypes () {
  return $_app_server.get("advocateventtypes").then(response => response.data)
}



function advocatApps () {
  return $_app_server.get("specialist/advocat/apps")
  .then(response => response.data)
}

function advocatApp (id) {
  return $_app_server.get("specialist/advocat/apps/"+id)
  .then(response => response.data)
}

function advocatAppCreate( advocatApp ) {
  return $_app_server.post("specialist/advocat/apps/" + advocatApp.caseId + "/member/" + advocatApp.caseMemberId, advocatApp).then(response => response.data)
}

function advocatAppItemCreate( appId, advocatItemApp ) {
  return $_app_server.post("specialist/advocat/apps/" + appId + "/items", advocatItemApp)
  .then(response => response.data)
}

function advocatAppItemUpdate( advocatItemApp ) {
  return $_app_server.put("specialist/advocat/items", advocatItemApp)
  .then(response => response.data)
}


function getCase (id) {
  return $_app_server.get("specialist/case/" + id)
  .then(response => response.data)
}

function findCase (number) {
  return $_app_server.get("specialist/case?number="+number)
  .then(response => response.data)
}

function findCases (number) {
  return $_app_server.get("specialist/cases?number="+number)
  .then(response => response.data)
}

function advocatAppSend (id) {
  return $_app_server.patch("specialist/advocat/send/"+id)
  .then(response => response.data)
}

function advocatAppDelete (id) {
  return $_app_server.delete("specialist/advocat/apps/"+id)
  .then(response => response.data)
}

function advocatAppItemDelete (id) {
  return $_app_server.delete("specialist/advocat/items/"+id)
  .then(response => response.data)
}


function saveAppItem (item) {
  return $_app_server.put("specialist/internal/advocat/save", item)
  .then(response => response.data)
}

function confirmApp (appId) {
  return $_app_server.patch("specialist/internal/advocat/confirmall/"+appId)
  .then(response => response.data)
}

function reestr (from, to) {
  return $_app_server.get("specialist/reestr?from="+from+"&to="+to)
 .then(response => response.data)
}



function groups () {
  return $_app_server.get("specialist/groups")
 .then(response => response.data)
}

function groupCreate( group ) {
    return $_app_server.post("specialist/groups", group).then(response => response.data)
}

function groupUpdate( group ) {
    return $_app_server.put("specialist/groups", group).then(response => response.data)
}



function specs () {
  return $_app_server.get("specialist/list")
 .then(response => response.data)
}

function specCreate( spec ) {
    return $_app_server.post("specialist/register", spec).then(response => response.data)
}

function specApprove( specId ) {
    return $_app_server.patch("specialist/approve/"+specId).then(response => response.data)
}

function getProfileById (specId) {
  return $_app_server.get("specialist/"+specId)
 .then(response => response.data)
}

function editSpecialist( spec ) {
    return $_app_server.put("specialist", spec).then(response => response.data)
}

function editProfile( spec ) {
    return $_app_server.put("specialist/profile", spec).then(response => response.data)
}

function editBankAccount( acc ) {
    return $_app_server.put("specialist/bankaccount", acc).then(response => response.data)
}

function makeReestr( ids ) {
    return $_app_server.post("specialist/makereestr", ids).then(response => response.data)
}

function signReestr( id ) {
    return $_app_server.patch("/specialist/reestr/"+id+"/sign").then(response => response.data)
}



function getAuthSpecialist () {
  return $_app_server.get('authspecialist').then(response => response.data)
}

function getAdvocatAppData (id) {
  return $_app_server.get("specialist/internal/advocat/data/"+id)
  .then(response => response.data)
}

function postAdvocatAppData (id, data) {
  return $_app_server.post("specialist/internal/advocat/data/"+id, data)
  .then(response => response.data)
}
